<template>
  <div id="HomePage">
    <!-- 轮播图 -->
    <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <img
              @dragstart.prevent
              class="swiper-lazy"
              :data-src="item.img"
              alt="轮播图"
            />
            <div class="swiper-lazy-preloader"></div>
            <div class="swiper-slide-title">
              <!-- <div> -->
              <h1>{{ item.title }}</h1>
              <p>{{ item.content }}</p>
              <div class="btnSee">
                <span>{{ item.btnContent }}</span>
                <img
                  @dragstart.prevent
                  style="width: 20px; height: 20px"
                  src="@/assets/img/Left.png"
                  alt=""
                />
              </div>
              <!-- </div> -->
            </div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>

    <!-- Tessai资管系统 -->
    <div id="bigData" class="container-fuild">
      <div class="bigDataBox">
        <img
          @dragstart.prevent
          style="height: 32px; padding: 4px 10px 0 10px"
          src="@/assets/img/Group.png"
          alt=""
        />
        <div style="font-size: 28px; height: 34px; font-weight: 500">
          核心业务赛道
        </div>
      </div>
      <div class="row bigData-container">
        <div class="bigDataImg col-xs-12 col-sm-12 col-md-6 wow zoomIn">
          <img
            @dragstart.prevent
            class="img-responsive"
            src="https://points-mall00.oss-cn-beijing.aliyuncs.com/integral/images/20240412/1.png"
            alt="Tessai资管系统"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <div class="marketbox">
            <transition name="run" appear>
              <div style="width: 296px; height: 110px">
                <img @dragstart.prevent :src="image[selecteImage].img" alt="" />
              </div>
            </transition>
            <div class="marketList">
              <ul class="marketList_list">
                <li
                  class="marketList_list_item"
                  v-for="(item, index) in marketList"
                  :key="index"
                  :class="{ activeClass: isActive(index) }"
                  @click="goActive(index)"
                >
                  {{ item.item }}
                </li>
              </ul>
            </div>
            <div class="btn">
              <span>立即了解</span>
              <img
                @dragstart.prevent
                style="width: 20px; height: 20px"
                src="@/assets/img/Left.png"
                alt=""
              />
            </div>
          </div>
          <!-- <h2 class="bigData-title">
            Tessai资管系统
            <small>/ Tessai Management System</small>
          </h2>
          <p>
            智能化办公，提升效率；流程人性化。监管数据可模块化填报；只能一键式全市场下单交易，后台自动跑批数据。
          </p>
          <p>
            我们的流线式网页布局设计方案和可视化图文内容编辑模式让网站制作和维护成为一件轻松惬意的事。无论您是普通互联网用户，还是专业网站制作人员。
          </p>
          <h2 class="bigData-device">PC &nbsp; Windows系统支持</h2>
          <a href="#" class="btn btn-lg btn-block btn-info">联系我们</a> -->
        </div>
      </div>
    </div>

    <div id="putAdv" class="container-fuild text-center">
      <div class="bigDataBox">
        <img
          @dragstart.prevent
          style="height: 32px; padding: 4px 10px 0 10px"
          src="@/assets/img/Group.png"
          alt=""
        />
        <div
          style="font-size: 28px; height: 34px; font-weight: 500；color：black"
        >
          投放优势
        </div>
      </div>
      <div class="put">
        <div class="put_container">
          <div class="put_container_left col-xs-12 col-sm-12 col-md-6">
            <div
              class="put_container_left_item"
              v-for="(item, index) in putList"
              :key="index"
            >
              <div class="put_container_left_item_img">
                <img @dragstart.prevent :src="item.img" alt="" />
              </div>
              <div class="put_container_left_item_txt">
                <div
                  class="put_container_left_item_title"
                  :class="{ activeClass1: isActive1(index) }"
                  @click="goActive1(index)"
                >
                  {{ item.title }}
                </div>
                <div class="put_container_left_item_content">
                  {{ item.content }}
                </div>
              </div>
            </div>
          </div>
          <div class="put_container_right col-xs-12 col-sm-12 col-md-6">
            <img
              @dragstart.prevent
              class="img-responsive"
              src="https://points-mall00.oss-cn-beijing.aliyuncs.com/integral/images/20240412/2.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 广告 -->
    <div class="adv_class">
      <div class="adv_title">
        <div class="scheme_container_title">
          <div class="bigDataBox">
            <img
              @dragstart.prevent
              style="height: 32px; padding: 4px 10px 0 0px"
              src="@/assets/img/Group.png"
              alt=""
            />
            <div
              style="
                font-size: 28px;
                height: 34px;
                font-weight: 500；color：black;
              "
            >
              最新资讯
            </div>
          </div>
          <!-- <div style="color: #7c7c7c" class="bigDataBox_bot">
            多领域布局，提供数字化运营与营销，技术研发与生态构建能力
          </div> -->
        </div>
      </div>
      <div class="adv_container">
        <div class="adv_left_box">
          <div
            class="adv_left_box_item"
            v-for="(item, index) in advList"
            :key="index"
          >
            <div class="adv_left_box_item1" @click="checkImg(item)">
              <div class="adv_left_box_item1_title">{{ item.title }}</div>
              <div class="adv_left_box_item1_time">{{ item.releaseTime }}</div>
            </div>
            <el-button type="text" @click="goDetail(item)">详情</el-button>
          </div>
        </div>
        <div class="adv_right_box">
          <div v-html="advContent" class="adv_right_box_item"></div>
        </div>
      </div>
    </div>

    <!-- 构建企业级全终端 -->
    <div id="scheme" class="container-fuild text-center">
      <div class="scheme_box">
        <div class="scheme_container">
          <div class="scheme_container_title">
            <div class="bigDataBox">
              <img
                @dragstart.prevent
                style="height: 32px; padding: 4px 10px 0 0px"
                src="@/assets/img/Group.png"
                alt=""
              />
              <div
                style="
                  font-size: 28px;
                  height: 34px;
                  font-weight: 500；color：black;
                "
              >
                构建企业级全终端+全场景积分商城解决方案
              </div>
            </div>
            <div style="color: #7c7c7c" class="bigDataBox_bot">
              多领域布局，提供数字化运营与营销，技术研发与生态构建能力
            </div>
          </div>

          <div class="imgBox swiper-containers">
            <div class="imgBox_container swiper-wrapper">
              <div
                class="imgBox_container_item swiper-slide"
                v-for="(item, index) in imgList"
                :key="index"
                @click="goDetails(item)"
              >
                <div class="txtPosition swiper-slide customer-block">
                  <img :src="item.img" alt="" width="821" />
                  <div class="txtPosition_title">
                    <div class="txtPosition_title_box">
                      <div class="txtPosition_title_box_icon"></div>
                      <div class="txtPosition_title_box_txt">
                        {{ item.descrition }}
                      </div>
                    </div>
                    <div style="padding: 8px 0">
                      <img
                        src="@/assets/img/line.png"
                        style="width: 90%"
                        alt=""
                      />
                    </div>
                    <div>{{ item.title }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="bg"></div>
      </div>
    </div>

    <!-- 多元化支付场景-引领营销新纪元 -->
    <div id="scheme" class="container-fuild text-center scene">
      <div class="scheme_box scene_box">
        <div class="scheme_container scene_box">
          <div class="scheme_container_title scene_top">
            <div class="bigDataBox">
              <img
                @dragstart.prevent
                style="height: 32px; padding: 4px 10px 0 0px"
                src="@/assets/img/Group.png"
                alt=""
              />
              <div
                style="
                  font-size: 28px;
                  height: 34px;
                  font-weight: 500；color：black;
                "
              >
                多元支付优惠场景-引领营销新纪元
              </div>
            </div>
            <div style="color: #7c7c7c">
              与微信&支付宝强强联合，降成本提效率，探索支付优惠新模式
            </div>
          </div>
          <div class="scene">
            <!-- <img src="@/assets/img/产品服务模块.png" alt="" /> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 商务联系请咨询 -->
    <!-- <div id="business">
      <div
        class="business_container"
        data-wow-duration="1.5s"
        data-wow-delay="0.5s"
      >
        <div class="business_box">
          <div class="business_box_title">
            <div class="bigDataBox">
              <img
                @dragstart.prevent
                style="height: 32px; padding: 4px 10px 0 0px"
                src="@/assets/img/Group.png"
                alt=""
              />
              <div
                style="
                  font-size: 28px;
                  height: 34px;
                  font-weight: 500；color：black;
                  letter-spacing: 8px;
                "
              >
                商务咨询请联系
              </div>
            </div>
            <div style="color: #7c7c7c">
              留下您的联系方式，我们的营销顾问免费为您服务
            </div>
          </div>
          <div class="form_box">
            <div class="form">
              <div class="form_container col-sm-2">
                <div class="relation_box">
                  <div class="relation_box_item">
                    <img
                      @dragstart.prevent
                      src="@/assets/img/phone.png"
                      alt=""
                    />
                    <div style="margin-left: 10px">021-60410579</div>
                  </div>
                  <div class="relation_box_item">
                    <img
                      @dragstart.prevent
                      src="@/assets/img/email.png"
                      alt=""
                    />
                    <div style="margin-left: 10px">king@kingcer.net</div>
                  </div>
                </div>
                <el-form
                  label-position="top"
                  label-width="auto"
                  :model="formLabelAlign"
                  style="max-width: 600px"
                >
                  <el-form-item label="姓名*">
                    <el-input v-model="formLabelAlign.name" />
                  </el-form-item>
                  <el-form-item label="联系方式*">
                    <el-input v-model="formLabelAlign.region" />
                  </el-form-item>
                  <el-form-item label="公司名称*">
                    <el-input v-model="formLabelAlign.type" />
                  </el-form-item>
                  <el-form-item label="所在省市*" prop="region">
                    <el-cascader
                      v-model="value"
                      :options="options"
                      :props="cascaderProps"
                      @change="handleChange"
                      style="width: 100%"
                    />
                  </el-form-item>
                </el-form>
                <el-button type="primary"
                  >预约顾问咨询<i
                    class="el-icon-arrow-right el-icon-arrow-right"
                  ></i
                ></el-button>
              </div>
            </div>
            <div class="map col-sm-12">
              <img @dragstart.prevent src="@/assets/img/map.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 您身边的IT专家 -->
    <!-- <div id="contactUs" class="container-fuild text-center">
      <div class="container contactUs-container wow slideInUp">
        <h1>您身边的IT专家</h1>
        <h3>7x24小时提供出色的IT服务</h3>
        <button
          class="btn btn-default btn-sm"
          onmouseleave="this.style.borderColor='#ffffff'; this.style.backgroundColor='#ffffff'; this.style.color='#3f3f3f';"
          onmouseenter="this.style.backgroundColor='transparent'; this.style.borderColor='#ffffff'; this.style.color='#ffffff';"
          @click="navToContactPage"
        >
          联系我们
        </button>
        <div class="contactUs-contactWay">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div> -->

    <!-- 客户评价 -->
    <!-- <div id="customer" class="container-fuild">
      <div class="container customer-container">
        <p class="customer-title text-center">客户评价</p> -->
    <!-- 电脑端客户评价 -->
    <!-- <div class="swiper-container customer-swiper hidden-xs">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide customer-block"
              v-for="(item, index) in customerList"
              :key="index"
            >
              <div class="customer-logo">
                <img class="center-block" :src="item.logo" alt="logo" />
              </div>
              <div class="customer-yh">
                <img src="@/assets/img/yinhao_left.png" alt="引号" />
              </div>
              <div class="customer-content1">
                <small>{{ item.content }}</small>
              </div>
              <div class="customer-content2">{{ item.title }}</div>
            </div>
          </div> -->
    <!-- 如果需要导航按钮 -->
    <!-- <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div> -->
    <!-- 手机端客户评价 -->
    <!-- <div class="row visible-xs customer-block">
          <div
            class="col-xs-12"
            v-for="(item, index) in customerList"
            :key="index"
          >
            <div class="customer-logo">
              <img class="center-block" :src="item.logo" alt="logo" />
            </div>
            <div class="customer-yh">
              <img src="@/assets/img/yinhao_left.png" alt="引号" />
            </div>
            <div class="customer-content1">
              <small>{{ item.content }}</small>
            </div>
            <div class="customer-content2">
              <small>{{ item.title }}</small>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 为什么选择我们 -->
    <!-- <div id="whyChooseUs" class="conatiner-fuild">
      <div class="container">
        <div class="whyChooseUs-title text-center">
          <p>为什么选择我们的服务</p>
          <p>THE REASON TO CHOOSING US</p>
        </div>
        <div class="row">
          <div
            class="col-xs-12 col-sm-6 col-md-3 server-wrapper"
            v-for="(item, index) in serverList"
            :key="index"
          >
            <div
              class="server-block wow slideInUp"
              onmouseenter="this.style.color='#28f';this.style.borderColor='#28f'"
              onmouseleave="this.style.color='#666';this.style.borderColor='#ccc'"
            >
              <img class="center-block" :src="item.logo" alt="logo" />
              <p class="text-center">{{ item.title }}</p>
              <div
                class="text-center"
                v-html="item.content"
                onmouseenter="this.style.color='#28f'"
                onmouseleave="this.style.color='#ccc'"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import Swiper from "swiper";
import { WOW } from "wowjs";
import provideData from "../../config/provice";
import api from "../api/api";
// import { Delete, Edit, Search, Share, Upload } from "@element-ui/icons-vue";
export default {
  name: "HomePage",
  data() {
    return {
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      options: [],
      cascaderProps: {
        expandTrigger: "hover",
        value: "value",
        label: "text",
        children: "children",
        checkStrictly: true,
      },
      advContent: "",

      value: [],

      showPicNum: 5,

      activeIndex: 0,
      activeIndex1: 0,
      imgList: [
        {
          img: "https://points-mall00.oss-cn-beijing.aliyuncs.com/integral/images/20240412/q.png",
          title: "专业数据分析",
          descrition: "积分商城搭建，创新营销玩法，专业技术开发",
        },
        {
          img: "https://points-mall00.oss-cn-beijing.aliyuncs.com/integral/images/20240412/w.png",
          title: "营销活动支持",
          descrition: "积分商城搭建，创新营销玩法，专业技术开发",
        },
        {
          img: "https://points-mall00.oss-cn-beijing.aliyuncs.com/integral/images/20240412/11.png",
          title: "全国客服中心",
          descrition: "积分商城搭建，创新营销玩法，专业技术开发",
        },
        {
          img: "https://points-mall00.oss-cn-beijing.aliyuncs.com/integral/images/20240412/e.png",
          title: "专属商城",
          descrition: "积分商城搭建，创新营销玩法，专业技术开发",
        },
      ],
      putList: [
        {
          img: require("@/assets/img/put1.png"),
          title: "精准定位受众人群",
          content:
            "多维定向能力轻松瞄准您的目标用户，实现精准投放和多样互动，在数亿活跃用户中找到您的目标用户，助力企业实现营销目标。",
        },
        {
          img: require("@/assets/img/put2.png"),
          title: "覆盖多种行业",
          content:
            "有效帮助企业推广移动应用，本地生活服务，品牌活动，增加在线销量，获得潜在的优质粉丝关注。",
        },
        {
          img: require("@/assets/img/put3.png"),
          title: "多渠道强效覆盖",
          content: "呈现在抖音、快手、微信朋友圈、公众号、QQ等多种场景。",
        },
      ],
      marketList: [
        { item: "字节跳动：广告服务代理、工具类优质服务商" },
        { item: "腾讯：社交媒体信息流广告、视频号、营销" },
        { item: "百度：搜索引擎平台" },
        { item: "快手：本地、KA、电商、运营商代理" },
        { item: "知乎：知识付费平台" },
        { item: "微博：社交平台" },
        { item: "哔哩哔哩：二次元平台" },
      ],
      image: [
        { img: require("@/assets/img/logo.png") },
        { img: require("@/assets/img/logos/tengxun1.png") },
        { img: require("@/assets/img/logos/baidu1.png") },
        { img: require("@/assets/img/logos/kuaishou1.png") },
        { img: require("@/assets/img/logos/zhihu1.png") },
        { img: require("@/assets/img/logos/weibo1.png") },
        { img: require("@/assets/img/logos/blbl1.png") },
      ],
      selecteImage: 0,

      swiperList: [
        {
          img: "https://points-mall00.oss-cn-beijing.aliyuncs.com/integral/images/20240426/4411.png",
          path: "",
          title: "支付宝、微信优质服务商",
          content: "专业运营团队服务平台支付满减优惠",
          btnContent: "立即咨询",
        },
        {
          img: "https://points-mall00.oss-cn-beijing.aliyuncs.com/integral/images/20240410/banner2.png",
          path: "",
          title: "汇聚全网顶尖流量，尽享卓越推广优势",
          content: "",
          btnContent: "立即咨询",
        },
        {
          img: "https://points-mall00.oss-cn-beijing.aliyuncs.com/integral/images/20240410/banner3.png",
          path: "",
          title: "海量权益产品尽在旭垚",
          content: "1000+优质品牌入驻",
          btnContent: "立即咨询",
        },
        {
          img: "https://points-mall00.oss-cn-beijing.aliyuncs.com/integral/images/20240410/banner4.png",
          path: "",
          title: "上海旭垚网络科技最新动态",
          content: "KINGCER HOT NEWS",
          btnContent: "立即查看",
        },
      ],
      customerList: [
        {
          logo: require("@/assets/img/logo_hp.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
        },
        {
          logo: require("@/assets/img/logo_kk.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
        },
        {
          logo: require("@/assets/img/logo_toyota.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
        },
        {
          logo: require("@/assets/img/logo_kk.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
        },
        {
          logo: require("@/assets/img/logo_hp.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
        },
        {
          logo: require("@/assets/img/logo_toyota.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
        },
        {
          logo: require("@/assets/img/logo_kk.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
        },
        {
          logo: require("@/assets/img/logo_hp.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
        },
        {
          logo: require("@/assets/img/logo_toyota.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
        },
        {
          logo: require("@/assets/img/logo_hp.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
        },
        {
          logo: require("@/assets/img/logo_kk.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
        },
        {
          logo: require("@/assets/img/logo_hp.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
        },
      ],
      serverList: [
        {
          logo: require("@/assets/img/tel.png"),
          title: "核心优势1",
          content: "<p>由专业客服提供人工服务</p>负责疑难问题和故障受理",
        },
        {
          logo: require("@/assets/img/computer.png"),
          title: "核心优势2",
          content:
            "<p>利用远程视频工具，提供协助</p>帮助客户进行调试、解决故障",
        },
        {
          logo: require("@/assets/img/qq.png"),
          title: "核心优势3",
          content:
            "<p>利用企业QQ提供在线解答</p>帮助企业快速准确解决问题和故障",
        },
        {
          logo: require("@/assets/img/skill.png"),
          title: "核心优势4",
          content: "<p>由技术支持工程师，负责问题解答</p>需求受理及故障受理",
        },
      ],
      advList: [],
    };
  },
  // watch() {

  // },
  mounted() {
    console.log("ffffffffff", window.screen.width);
    if (window.screen.width <= 768) {
      this.showPicNum = 2;
    }
    console.log("provideDataprovideData", provideData.provideData);
    this.options = provideData.provideData;
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true, // 循环模式选项
      effect: "fade",
      //自动播放
      autoplay: {
        // enabled: false,
        delay: 1000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true,
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
    });

    new Swiper(".swiper-containers", {
      slidesPerView: this.showPicNum,
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      //自动播放
      autoplay: {
        // enabled: false,
        delay: 1500,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      // pagination: {
      //   el: ".swiper-pagination",
      //   clickable: true,
      // },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    /* customer-swiper */
    new Swiper(".customer-swiper", {
      loop: true, // 循环模式选项
      slidesPerView: 3,
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
    });
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
  },
  created() {
    this.getBanner();
    this.getDataList();
  },
  methods: {
    goDetail(item) {
      console.log("------------", item);
      localStorage.setItem("itemContent", JSON.stringify(item));
      this.$router.push("/NewsInformationDetail");
    },
    checkImg(item) {
      console.log("0000000000000000", item);
      this.advContent = item.content;
    },
    handleChange(value) {
      console.log(value);
    },
    getDataList() {
      const pamras = {
        index: null,
        name_id: 2,
        pageSize: 1000,
        states: 1,
      };
      api.getData(pamras).then((res) => {
        console.log(res);
        //   res.list.map((item) => {
        //     item.img =
        //       "https://points-mall00.oss-cn-beijing.aliyuncs.com/integral/images/20240410/media1.png";
        //   });
        //   console.log("res.list", res.list);
        this.advList = res.list;
        this.advContent = res.list[0].content;
      });
    },

    getBanner() {
      // api.getBannerList().then((res) => {
      // console.log("----------------", res);
      // this.swiperList = res;
      // });
    },

    goDetails(item) {
      console.log("-------------", item);
    },
    isActive(index) {
      console.log("------111", index);
      return this.activeIndex === index;
    },
    isActive1(index) {
      console.log("------111", index);
      return this.activeIndex1 === index;
    },
    goActive(index) {
      this.selecteImage = index;
      // this.isShow = !this.isShow;
      // this.selecteImage = this.img[i];

      this.activeIndex = index;
    },
    goActive1(index) {
      this.activeIndex1 = index;
    },
    /** 前往联系我们页面 */
    navToContactPage() {},
  },
};
</script>
<style scoped>
.adv_class {
  width: 75%;
  margin: 0 auto;
  padding: 30px 0;
}

.adv_class .bigDataBox {
  display: flex;
}
.adv_left_box {
  height: 380px;
  overflow-y: scroll;
  width: 580px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.adv_class .adv_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.adv_left_box_item {
  display: flex;
  justify-content: space-between;
  /* padding: 10px 0;
  font-size: 15px;
  cursor: pointer; */
}

.adv_left_box_item1 {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  font-size: 15px;
  cursor: pointer;
  width: 475px;
}
.adv_left_box_item1 .adv_left_box_item1_title {
  width: 375px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.adv_left_box_item1:hover {
  color: lightblue;
}

.adv_right_box {
  width: 580px;
  height: 380px;
  overflow-y: scroll;
}
.adv_right_box .adv_left_box_item {
  display: flex;
  justify-content: space-between;
}

>>> .adv_right_box_item p img {
  width: 100%;
}

.run-enter-active {
  animation: lightSpeedInRight 2s linear 0s;
}
.run-leave-active {
  animation: lightSpeedOutRight 2s linear 0s;
}

>>> .swiper-button-prev {
  width: 60px;
  height: 60px;
  top: 88% !important;
  left: 78% !important;
  background: url("../assets/img/箭头.png") 100% 100% no-repeat !important;
}
>>> .swiper-button-next {
  width: 60px;
  height: 60px;
  top: 88% !important;
  left: 83% !important;
  background: url("../assets/img/箭头1.png") 100% 100% no-repeat !important;
}
.imgBox {
  overflow: hidden;
}
.imgBox .imgBox_container {
  /* width: 75%; */
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.imgBox .imgBox_container .imgBox_container_item {
}
.imgBox .imgBox_container .imgBox_container_item .txtPosition {
  position: relative;
}
.imgBox
  .imgBox_container
  .imgBox_container_item
  .txtPosition
  .txtPosition_title {
  width: 14vw;
  position: absolute;
  color: white;
  font-size: 20px;
  font-weight: bold;
  bottom: 2vh;
  left: 2vh;
  display: flex;
  flex-direction: column;
  text-align: left;
}
.imgBox
  .imgBox_container
  .imgBox_container_item
  .txtPosition
  .txtPosition_title
  .txtPosition_title_box
  .txtPosition_title_box_txt {
  font-size: 13px;
  color: #999999;
}
.imgBox .imgBox_container .imgBox_container_item:hover {
  /* transform: scale(1.1); */
  /* transition: 1s; */
}
.imgBox .imgBox_container .imgBox_container_item img {
  width: 130%;
}

.bigData-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.activeClass {
  color: black !important;
  /* list-sytle: inline-block; */
  font-size: 1vw;
  font-weight: bold;
  position: relative;
  /* cursor: pointer !important; */
}

.activeClass1 {
  color: #2358fe !important;
  font-size: 1vw;
  font-weight: bold;
  /* position: relative; */
}

.activeClass:before {
  position: absolute;
  content: "";
  width: 10px;
  height: 10px;
  display: inline-block;
  border-radius: 50%;
  background: #4f8eff;
  vertical-align: middle;
  margin-right: 14px;
  left: -20px;
  top: 14px;
}

.marketbox {
  padding: 0px 200px 0 100px;
}
.marketList > .marketList_list > .marketList_list_item {
  padding: 1vh 0;
  color: #b1b1b1;
  cursor: pointer;
}
.btn {
  display: flex;
  align-items: center;
  height: 50px;
  width: 110px;
  background: linear-gradient(to right, #1358fe, #09a1ff);
  justify-content: center;
}
.btn span {
  color: white;
}
/* 整体盒子 */
#HomePage {
  width: 100%;
}

/* 轮播图 */
#swiper {
  /* height: 600px; */
}
#swiper .banner-swiper {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide {
  position: relative;
}
#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  text-align: center;
  line-height: 80px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 50px;
  /* margin-top: 12%; */
  margin-left: 25%;
  color: black;
}
#swiper .banner-swiper .swiper-slide-title .btnSee {
  display: flex;
  align-items: center;
  height: 50px;
  width: 110px;
  background: linear-gradient(to right, #1358fe, #09a1ff);
  justify-content: center;
}
#swiper .banner-swiper .swiper-slide-title .btnSee > span {
  font-size: 16px;
  color: white;
  text-align: center;
}
#swiper .banner-swiper .swiper-slide-title > h1 {
  width: 500px;
  text-align: left;
  font-size: 40px;
  margin-top: 12%;
}
#swiper .banner-swiper .swiper-slide-title > p {
  font-size: 18px;
  color: #686868;
  /* margin-top: 1%; */
  /* font-weight: 700; */
}
/* 大数据管理系统 */
#bigData {
  padding: 70px 100px 100px 0;
  transition: all ease 0.6s;
  box-sizing: border-box;
}
#bigData .bigDataBox,
#putAdv .bigDataBox,
#scheme .bigDataBox {
  display: flex;
  justify-content: center;
  align-items: center;
}
#scheme .scheme_box {
  position: relative;
  padding-bottom: 14vh;
  z-index: 999;

  /* background: url("../assets/img/bg_dot.png") 0 0 no-repeat; */
}
.scene_box {
  height: 100vh;
  /* background: url(/static/img/产品服务模块.44afaa0.png) 0 0 no-repeat; */
}
.bg {
  position: absolute;
  width: 100%;
  height: 400px;
  bottom: 0;
  background-color: #0ce9f1;
  z-index: -99;
  background: url("../assets/img/bg_dot.png") 0 0;
}
#bigData .bigDataBox img {
  padding: 0 10px;
  /* display: flex;
  justify-content: center; */
}
#bigData .bigData-title {
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
#bigData p {
  font-size: 14px;
  color: #333;
  line-height: 2rem;
}
#bigData .bigData-device {
  margin: 50px 0 20px;
}

/* 投放优势 */
#putAdv {
  color: black;
  /* height: 100vh; */
  background: url("../assets/img/put_bg.png") 0 0 no-repeat;
  background-size: 100% 100%;
  transition: all ease 0.6s;
  padding-bottom: 10vh;
}
.put .put_container {
  height: 60vh;
}

.map img {
  width: 100%;
}

.put .put_container .put_container_left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 80%;
  vertical-align: middle;
}

.put .put_container .put_container_left .put_container_left_item {
  display: flex;
  align-items: center;
}

.put .put_container .put_container_right img {
  /* width: 60% !important; */
}

.put
  .put_container
  .put_container_left
  .put_container_left_item
  .put_container_left_item_txt {
  width: 18vw;
  text-align: left;
  padding-left: 20px;
}

.put
  .put_container
  .put_container_left
  .put_container_left_item
  .put_container_left_item_txt
  .put_container_left_item_title {
  font-size: 22px;
  font-weight: 500;
  cursor: pointer;
}

.put
  .put_container
  .put_container_left
  .put_container_left_item
  .put_container_left_item_txt
  .put_container_left_item_content {
  font-size: 13px;
  color: #89898a;
  padding: 20px 0 0 0;
}

.put
  .put_container
  .put_container_left
  .put_container_left_item
  .put_container_left_item_txt
  .put_container_left_item_content:hover {
  text-decoration: underline;
  cursor: pointer;
}

#putAdv .bigDataBox {
  padding: 7vh 0;
}

/* 解决方案 */
#scheme {
  color: black;
  /* height: 100vh; */
  /* background: url("../assets/img/bg_dot.png") 0 0 no-repeat; */
  background-size: 100% 100%;
  transition: all ease 0.6s;
  /* padding-bottom: 10vh; */
}
#scheme .bigDataBox {
  padding: 2vh 0;
  justify-content: left !important;
}

#scheme .scheme_container {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 75%;
}

/* .scene_box {
  position: relative;
} */
.scene {
  /* position: absolute; */
  /* height: 100vh !important; */
  background: url("https://points-mall00.oss-cn-beijing.aliyuncs.com/integral/images/20240426/旭垚产品服务模块.png")
    0 0 no-repeat;
}
.scene .scheme_container_title {
  /* position: absolute; */
  margin: 0 auto;
}
#scheme .scheme_container_title {
  display: flex;
  flex-direction: column;
  width: 75%;
  margin: 50px 0px 50px 0px;
  text-align: left;
  /* text-align: left; */
}
.scene_top {
  padding: 50px 0px 80px 0px !important;
  margin: 0 !important;
}

/* 商务联系 */
#business {
  color: black;
  background-size: 100% 100%;
  transition: all ease 0.6s;
}

#business .business_box {
  width: 75%;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 14vh;
  margin: 0 auto;

  /* background: url("../assets/img/bg_dot.png") 0 0 no-repeat; */
}
#business .business_box_title {
  display: flex;
  flex-direction: column;
  width: 75%;
  margin: 50px 0px 50px 0px;
  text-align: left;
}

.relation_box {
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
}

.relation_box .relation_box_item {
  display: flex;
  width: 50%;
  justify-content: flex-start;
  align-items: center;
}

#business .bigDataBox {
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 2vh 0;
}
#business .form_box {
  display: flex;
  justify-content: space-between;
}
.form_box .form {
  width: 100%;
}

.form .form_container {
  width: 80%;
  padding-left: 0 !important;
}

/* 您身边的IT专家 */
#contactUs {
  color: #fff;
  height: 400px;
  background: url("../assets/img/contact_us_bg.jpg") 0 0 no-repeat;
  background-size: 100% 100%;
  transition: all ease 0.6s;
}
#contactUs .contactUs-container {
  padding-top: 50px;
}
#contactUs .contactUs-container button {
  width: 300px;
  height: 50px;
  margin-top: 40px;
}
#contactUs .contactUs-container .contactUs-contactWay span {
  display: inline-block;
  width: 48px;
  height: 48px;
  margin: 30px;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(1) {
  background: url("../assets/img/weixin.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(2) {
  background: url("../assets/img/weibo.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(3) {
  background: url("../assets/img/twitter.png") 0 0 no-repeat;
  background-size: 100% 100%;
}

/* 客户评价 */
#customer {
  padding: 50px 0;
  box-sizing: border-box;
  background: #efefef;
  transition: all ease 0.6s;
}
#customer .customer-title {
  font-size: 30px;
  color: rgb(102, 102, 102);
  margin: 0 0 30px;
}
#customer .customer-block {
  background: #fff;
  padding: 30px;
}
#customer .customer-logo img {
  width: 94px;
  height: 94px;
  border: 1px solid #ccc;
}
#customer .customer-yh img {
  width: 34px;
  height: 34px;
}
#customer .customer-content1 {
  padding-bottom: 20px;
  border-bottom: 1px solid #0ce9f1;
}
#customer .customer-content2 {
  padding-top: 20px;
}
/* 为什么选择我们 */
#whyChooseUs {
  padding: 100px;
}
#whyChooseUs .whyChooseUs-title {
  margin-bottom: 50px;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
  font-size: 25px;
  font-weight: 500;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
  font-size: 14px;
}
#whyChooseUs .server-block {
  padding: 50px 20px;
  border: 1px solid #ccc;
  border-bottom: 5px solid #ccc;
}
#whyChooseUs .server-block img {
  width: 48px;
  height: 48px;
}
#whyChooseUs .server-block > p {
  font-size: 20px;
  margin: 30px 0;
}
#whyChooseUs .server-block > div {
  color: #ccc;
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .imgBox .imgBox_container .imgBox_container_item img {
    width: 90%;
  }
  .scheme_container {
    width: 100% !important;
  }
  .scheme_container_title {
    /* margin: 0 20px !important; */
  }
  #scheme .scheme_container_title {
    margin: 0 20px !important;
  }
  #scheme .bigDataBox div {
    line-height: 34px;
  }
  .adv_class {
    width: 90%;
  }
  .adv_container {
    margin-top: 20px;
  }
  .adv_left_box {
    width: 100% !important;
  }
  .adv_left_box_item1_title {
    width: 210px !important;
  }
  .adv_left_box_item1 {
  }
  .adv_left_box_item1_time {
    width: 100px;
  }
  #swiper {
    height: 200px;
  }
  #bigData {
    padding: 30px;
  }
  #bigData .bigData-title {
    font-size: 20px;
  }
  #bigData .bigData-device {
    font-size: 20px;
    margin: 10px 0 10px;
  }
  #contactUs {
    height: 200px;
    transition: all ease 0.6s;
  }
  #contactUs .contactUs-container {
    padding-top: 0;
  }
  #contactUs .contactUs-container h1 {
    font-size: 25px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 18px;
  }
  #contactUs .contactUs-container button {
    width: 200px;
    height: 30px;
    margin-top: 20px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin: 10px;
  }
  #customer {
    padding: 30px 0;
    box-sizing: border-box;
    background: #fff;
  }
  #customer .customer-title {
    font-size: 16px;
    font-weight: bold;
  }
  #customer .customer-logo img {
    width: 48px;
    height: 48px;
  }
  #customer .customer-block {
    padding: 30px;
  }
  #customer .customer-block > div {
    padding: 30px 0;
  }
  #whyChooseUs {
    padding: 20px 0;
    transition: all ease 0.6s;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
    font-size: 20px;
    font-weight: 700;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
    font-size: 12px;
  }
  #whyChooseUs .server-block {
    padding: 50px 0;
    border: 1px solid #ccc;
    border-bottom: 5px solid #ccc;
  }
  #whyChooseUs .server-block img {
    width: 48px;
    height: 48px;
  }
  #whyChooseUs .server-block > p {
    font-size: 20px;
    margin: 30px 0;
  }
  #whyChooseUs .server-block > div {
    color: #ccc;
  }

  .swiper-slide-title > h1 {
    font-size: 23px !important;
  }
  .swiper-slide-title > p {
    height: 30px;
    line-height: 30px;
    font-size: 16px;
  }
  #swiper .banner-swiper .swiper-slide-title .btnSee {
    display: flex;
    align-items: center;
    height: 35px;
    width: 80px;
    background: linear-gradient(to right, #1358fe, #09a1ff);
    justify-content: center;
  }
  #swiper .banner-swiper .swiper-slide-title .btnSee > span {
    font-size: 13px;
    color: white;
    text-align: center;
    width: 52px;
    height: 30px;
    line-height: 34px;
  }
  .swiper-button-prev {
    width: 35px;
    height: 50px;
    top: 88% !important;
    left: 78% !important;
    background: url("../assets/img/箭头2.png") 100% 100% no-repeat !important;
  }
  .swiper-button-next {
    width: 45px;
    height: 50px;
    top: 88% !important;
    left: 83% !important;
    background: url("../assets/img/箭头3.png") 100% 100% no-repeat !important;
  }
  #swiper .banner-swiper .swiper-slide-title > h1 {
    width: 260px;
    text-align: left;
    font-size: 40px;
    margin-top: 12%;
  }
  .marketbox {
    padding: 0px;
  }
  .bigDataImg {
    display: none;
  }
  .activeClass {
    font-size: 18px;
  }
  .put
    .put_container
    .put_container_left
    .put_container_left_item
    .put_container_left_item_txt {
    width: 100%;
    text-align: left;
    padding-left: 20px;
  }
  .put_container_right {
    display: none;
  }
  #bigData .bigDataBox img {
    height: 23px !important; /* padding: 0 10px; */
    padding: 0 10px;
  }
  #bigData .bigDataBox div {
    font-size: 23px !important;
    height: 34px !important;
  }
  .marketbox img {
    width: 80%;
  }
  #putAdv .bigDataBox img {
    padding: 0 10px !important;
    height: 24px !important;
  }
  #putAdv .bigDataBox div {
    font-size: 23px !important;
    height: 28px !important;
  }
  #putAdv .bigDataBox {
    padding: 4vh 0 !important;
  }
  .put .put_container .put_container_left {
    height: 80%;
  }
  #putAdv {
    padding-bottom: 0;
  }
  #scheme .bigDataBox div {
    font-size: 20px !important;
    height: 34px !important;
  }

  #scheme .scheme_container_title .bigDataBox_bot {
    margin: 40px 15px 0 15px;
  }
  #scheme .scheme_box {
  }
  #scheme .scheme_container_title {
    width: 90% !important;
    margin: 40px 0 40px 0;
  }
  .bg {
    height: 200px;
  }
  .scheme_container_title {
    /* width: 100% !important; */
  }
  .imgBox
    .imgBox_container
    .imgBox_container_item
    .txtPosition
    .txtPosition_title {
    width: 100%;
  }
  #scheme .scheme_box {
    padding-bottom: 0;
  }
  .scene_box {
    height: 30vh;
  }
  #scheme .bigDataBox {
    padding: 2vh 0 0 0 !important;
  }

  .scene_top {
    padding: 0 !important;
  }
  #business .business_box_title {
    width: 100%;
  }
  .form_box {
    flex-direction: column;
  }
  .form .form_container {
    width: 100% !important;
  }
  .map {
    width: 100% !important;
    padding: 20px 0 0 0 !important;
  }
  #business .business_box {
    width: 90%;

    /* background: url("../assets/img/bg_dot.png") 0 0 no-repeat; */
  }
}
@media screen and (min-width: 1344px) and (max-width: 1600px) {
  .map img {
    width: 120%;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #swiper {
    height: 400px;
  }
  #bigData {
    padding: 60px;
  }
  #bigData .bigData-title {
    font-size: 30px;
  }
  #bigData .bigData-device {
    font-size: 30px;
    margin: 30px 0 15px;
  }
  #contactUs {
    height: 300px;
  }
  #contactUs .contactUs-container {
    padding-top: 50px;
  }
  #contactUs .contactUs-container h1 {
    font-size: 30px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 20px;
  }
  #contactUs .contactUs-container button {
    width: 300px;
    height: 50px;
    margin-top: 30px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin: 15px;
  }
  #customer .customer-title {
    font-size: 24px;
  }
  #whyChooseUs {
    padding: 20px 0;
  }
}

/deep/ .el-form-item__label {
  line-height: 10px !important;
  padding: 0 !important;
}
.swiper-container {
  position: relative;
  width: 100%;
  height: 500px;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  /* background: #eee; */
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.8);
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}
</style>




// WEBPACK FOOTER //
// src/view/HomePage.vue